import { useTranslations } from '@vocab/react';
import {
  ButtonIcon,
  Dialog,
  IconInfo,
  Inline,
  Stack,
  Text,
  TextLink,
} from 'braid-design-system';
import { useCallback, useState } from 'react';

import translations from './.vocab';

interface Props {
  primaryLocation?: string;
  traditionalLand?: string;
  traditionalPlace?: string;
}

export const PrimaryLocation = ({
  traditionalLand,
  primaryLocation,
  traditionalPlace,
}: Props) => {
  const [showDialog, setShowDialog] = useState(false);

  const { t } = useTranslations(translations);

  const onTraditionalLandClick = useCallback(() => {
    setShowDialog(true);
  }, []);

  const onDialogClose = useCallback(() => {
    setShowDialog(false);
  }, []);

  if (!traditionalLand && !traditionalPlace) {
    return <Text>{primaryLocation}</Text>;
  }

  const traditionalPlaceAndLandText = [traditionalPlace, traditionalLand]
    .filter(Boolean)
    .join(', ');

  return (
    <>
      <Stack space="gutter">
        <Text>{primaryLocation}</Text>
        <Inline space="xsmall" alignY="center">
          <Text>{traditionalPlaceAndLandText}</Text>
          <ButtonIcon
            size="small"
            icon={<IconInfo />}
            label={t('Traditional land dialog Label')}
            onClick={onTraditionalLandClick}
            variant="transparent"
          />
        </Inline>
      </Stack>
      <Dialog
        title={t('Traditional land dialog title')}
        open={showDialog}
        onClose={onDialogClose}
      >
        <Stack space="gutter">
          <Text>{t('Traditional land dialog content 1')}</Text>
          <Text>{t('Traditional land dialog content 2')}</Text>
          <Text>
            {t('Traditional land dialog content 3', {
              TextLink: (text) => (
                <TextLink
                  href="/about/sustainability/social-impact#engagement-with-First-Nations"
                  weight="weak"
                  target="_blank"
                >
                  {text}
                </TextLink>
              ),
            })}
          </Text>
        </Stack>
      </Dialog>
    </>
  );
};
